module.exports = __webpack_public_path__ + "static/media/abdomen.56a3d64e.svg";